// extracted by mini-css-extract-plugin
export var container = "index-module--container--n84D+";
export var image = "index-module--image--nAb4r";
export var info = "index-module--info--+DIAQ";
export var lightWrapper = "index-module--lightWrapper--iZtTh";
export var secondaryInfo = "index-module--secondaryInfo--Pp+xY";
export var triggered = "index-module--triggered--kCr3w";